module.exports = __webpack_public_path__ + "img/product_advantages_3.702d8e92.png";